/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						this.querySelectorAll('.lazyload').forEach((image) => {
							lazySizes.loader.unveil(image);
						});

						if (this.cart) {
							this.addCartButtons();
						}
					}

					this.classList.add('product-recommendations--loaded');

				})
				.catch(e => {
					console.error(e);
				});
		}
		async addCartButtons() {
			const productCards = this.querySelectorAll('product-card');
			for (const card of productCards) {
				const link = card.querySelector('a[href*="/products/"]');
				if (!link) continue;
				const handle = link.getAttribute('href').split('/products/')[1]?.split('?')[0];
				if (!handle) continue;

				try {
					const res = await fetch(`/products/${handle}.js`);
					const data = await res.json();
					const variant = data.variants?.find(v => v.available) || data.variants?.[0];
					const available = variant?.available ?? true;
					const variantId = variant?.id;

					const infoDiv = card.querySelector('.product-cart-item-info');
					if (!infoDiv) continue;

					if (available && variantId) {
						const btn = document.createElement('button');
						btn.type = 'button';
						btn.className = 'cart-reco--add-btn';
						btn.dataset.variantId = variantId;
						btn.textContent = 'Ajouter au panier';
						btn.addEventListener('click', (e) => this.handleAddToCart(e, btn));
						infoDiv.appendChild(btn);
					} else {
						const span = document.createElement('span');
						span.className = 'cart-reco--sold-out';
						span.textContent = 'Épuisé';
						infoDiv.appendChild(span);
					}
				} catch (e) {}
			}
		}
		async handleAddToCart(e, btn) {
			e.preventDefault();
			const variantId = btn.dataset.variantId;
			if (!variantId) return;

			btn.disabled = true;
			btn.textContent = 'Ajout...';

			try {
				const response = await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
				});

				if (!response.ok) throw new Error('Add failed');

				btn.textContent = 'Ajouté !';
				btn.style.background = '#0e5757';
				btn.style.color = '#fff';

				setTimeout(() => {
					window.location.reload();
				}, 800);

			} catch (error) {
				btn.textContent = 'Erreur';
				setTimeout(() => {
					btn.textContent = 'Ajouter au panier';
					btn.disabled = false;
				}, 2000);
			}
		}
		connectedCallback() {
			this.fetchProducts();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
